export default class ConsoleOnlyError extends Error {
  name = 'ConsoleOnlyError'
}
